import { ThemeConfigType } from './typing';
const colorBgContainer = '#FFFFFF'; // Very light background for high contrast
const colorBgLayout = '#FFFFFF'; // Slightly darker than the container for contrast

const themeId = 'light-high-contrast';

export const lightHighContrastTheme: ThemeConfigType = {
  id: themeId,
  type: 'light',
  name: `themes.${themeId}`,
  previewImage:
    'https://github.githubassets.com/assets/light_high_contrast_preview-610b54d7c5b1.svg',
  previewImageDisc:
    'https://github.githubassets.com/assets/light_high_contrast_disc-f74abfa8e811.svg',
  theme: {
    algorithm: [],
    token: {
      blue: '#1D39C4',
      purple: '#531DAB',
      cyan: '#13C2C2',
      green: '#52C41A',
      magenta: '#EB2F96',
      pink: '#EB2F96',
      red: '#F5222D',
      orange: '#FA8C16',
      yellow: '#FADB14',
      volcano: '#FA541C',
      geekblue: '#2F54EB',
      gold: '#FAAD14',
      lime: '#A0D911',
      colorPrimary: '#1D39C4',
      colorSuccess: '#52C41A',
      colorWarning: '#FAAD14',
      colorError: '#F5222D',
      colorInfo: '#1890FF',
      colorLink: '#1D39C4',
      colorTextBase: '#000000',
      colorBgBase: '#FFFFFF',
      lineWidth: 1,
      lineType: 'solid',
      borderRadius: 6,
      colorText: '#000000',
      colorTextSecondary: 'rgba(0, 0, 0, 0.85)',
      colorTextTertiary: 'rgba(0, 0, 0, 0.65)',
      colorTextQuaternary: 'rgba(0, 0, 0, 0.45)',
      colorFill: 'rgba(0, 0, 0, 0.15)',
      colorFillSecondary: 'rgba(0, 0, 0, 0.06)',
      colorFillTertiary: 'rgba(0, 0, 0, 0.04)',
      colorFillQuaternary: 'rgba(0, 0, 0, 0.02)',
      colorBgLayout: colorBgLayout,
      colorBgContainer: colorBgContainer,
      colorBgElevated: '#FFFFFF',
      colorBgSpotlight: 'rgba(0, 0, 0, 0.85)',
      colorBgBlur: 'transparent',
      colorBorder: '#000000',
      colorBorderSecondary: '#000000',
      // colorPrimaryBg: '#E6F7FF',
      // colorPrimaryBgHover: '#BAE7FF',
      // colorPrimaryBorder: '#91D5FF',
      // colorPrimaryBorderHover: '#69C0FF',
      // colorPrimaryHover: '#40A9FF',
      // colorPrimaryActive: '#096DD9',
      // colorPrimaryTextHover: '#40A9FF',
      // colorPrimaryText: '#096DD9',
      // colorPrimaryTextActive: '#0050B3',
      colorSuccessBg: '#F6FFED',
      colorSuccessBgHover: '#D9F7BE',
      colorSuccessBorder: '#B7EB8F',
      colorSuccessBorderHover: '#95DE64',
      colorSuccessHover: '#73D13D',
      colorSuccessActive: '#389E0D',
      colorSuccessTextHover: '#73D13D',
      colorSuccessText: '#389E0D',
      colorSuccessTextActive: '#237804',
      colorErrorBg: '#FFF2F0',
      colorErrorBgHover: '#FFD8D5',
      colorErrorBgActive: '#FFCCC7',
      colorErrorBorder: '#FFA39E',
      colorErrorBorderHover: '#FF7875',
      colorErrorHover: '#FF4D4F',
      colorErrorActive: '#D9363E',
      colorErrorTextHover: '#FF4D4F',
      colorErrorText: '#D9363E',
      colorErrorTextActive: '#AD2102',
      colorWarningBg: '#FFFBE6',
      colorWarningBgHover: '#FFF1B8',
      colorWarningBorder: '#FFE58F',
      colorWarningBorderHover: '#FFD666',
      colorWarningHover: '#FFC53D',
      colorWarningActive: '#D48806',
      colorWarningTextHover: '#FFC53D',
      colorWarningText: '#D48806',
      colorWarningTextActive: '#AD6800',
      colorInfoBg: '#E6F7FF',
      colorInfoBgHover: '#BAE7FF',
      colorInfoBorder: '#91D5FF',
      colorInfoBorderHover: '#69C0FF',
      colorInfoHover: '#40A9FF',
      colorInfoActive: '#096DD9',
      colorInfoTextHover: '#40A9FF',
      colorInfoText: '#096DD9',
      colorInfoTextActive: '#0050B3',
      colorLinkHover: '#2F54EB',
      colorLinkActive: '#1D39C4',
      colorBgMask: 'rgba(0, 0, 0, 0.45)',
      colorWhite: '#FFFFFF',
      lineWidthBold: 2,
      colorFillContent: 'rgba(0, 0, 0, 0.15)',
      colorFillContentHover: 'rgba(0, 0, 0, 0.06)',
      colorFillAlter: 'rgba(0, 0, 0, 0.04)',
      colorBgContainerDisabled: 'rgba(0, 0, 0, 0.02)',
      colorBorderBg: '#D9D9D9',
      colorSplit: 'rgba(0, 0, 0, 255)',
      colorTextPlaceholder: 'rgba(0, 0, 0, 0.15)',
      colorTextDisabled: 'rgba(0, 0, 0, 0.25)',
      colorTextHeading: 'rgba(0, 0, 0, 0.85)',
      colorTextLabel: 'rgba(0, 0, 0, 0.85)',
      colorTextDescription: 'rgba(0, 0, 0, 0.45)',
      colorTextLightSolid: '#FFFFFF',
      colorHighlight: '#1890FF',
      colorBgTextHover: 'rgba(0, 0, 0, 0.06)',
      colorBgTextActive: 'rgba(0, 0, 0, 0.15)',
      colorIcon: 'rgba(0, 0, 0, 0.25)',
      colorIconHover: 'rgba(0, 0, 0, 0.45)',
      colorErrorOutline: 'rgba(255, 77, 79, 0.6)',
      colorWarningOutline: 'rgba(250, 140, 22, 0.6)',
      controlItemBgHover: 'rgba(0, 0, 0, 0.06)',
      controlItemBgActive: '#D9D9D9',
      controlItemBgActiveHover: '#BFBFBF',
      controlItemBgActiveDisabled: 'rgba(0, 0, 0, 0.02)',
      controlTmpOutline: 'rgba(0, 0, 0, 0.06)',
      controlOutline: 'rgba(0, 0, 0, 0.45)',
      linkDecoration: 'none',
      linkHoverDecoration: 'underline',
      linkFocusDecoration: 'underline',
      boxShadow:
        '\n      0 6px 16px 0 rgba(0, 0, 0, 0.15),\n      0 3px 6px -4px rgba(0, 0, 0, 0.06),\n      0 9px 28px 8px rgba(0, 0, 0, 0.04)\n    ',
      boxShadowSecondary:
        '\n      0 6px 16px 0 rgba(0, 0, 0, 0.15),\n      0 3px 6px -4px rgba(0, 0, 0, 0.06),\n      0 9px 28px 8px rgba(0, 0, 0, 0.04)\n    ',
      boxShadowTertiary:
        '\n      0 1px 2px 0 rgba(0, 0, 0, 0.06),\n      0 1px 6px -1px rgba(0, 0, 0, 0.04),\n      0 2px 4px 0 rgba(0, 0, 0, 0.02)\n    ',
    },
  },
  layout: {
    hashId: themeId,
    colorPrimary: '#1D39C4',
    colorTextAppListIcon: 'rgba(0, 0, 0, 0.65)',
    colorBgAppListIconHover: 'rgba(0, 0, 0, 0.06)',
    colorTextAppListIconHover: 'rgba(0, 0, 0, 0.85)',
    bgLayout: `linear-gradient(${colorBgContainer}, ${colorBgLayout} 28%)`,
    sider: {
      paddingInlineLayoutMenu: 8,
      paddingBlockLayoutMenu: 0,
      colorBgCollapsedButton: '#E6F7FF',
      colorTextCollapsedButtonHover: 'rgba(0, 0, 0, 0.85)',
      colorTextCollapsedButton: 'rgba(0, 0, 0, 0.65)',
      colorMenuBackground: 'transparent',
      colorMenuItemDivider: 'rgba(0, 0, 0, 0.06)',
      colorBgMenuItemHover: 'rgba(0, 0, 0, 0.06)',
      colorBgMenuItemSelected: 'rgba(0, 0, 0, 0.15)',
      colorTextMenuItemHover: 'rgba(0, 0, 0, 0.85)',
      colorTextMenuSelected: 'rgba(0, 0, 0, 0.85)',
      colorTextMenuActive: 'rgba(0, 0, 0, 0.65)',
      colorTextMenu: 'rgba(0, 0, 0, 0.65)',
      colorTextMenuSecondary: 'rgba(0, 0, 0, 0.45)',
      colorTextMenuTitle: 'rgba(0, 0, 0, 0.85)',
      colorTextSubMenuSelected: 'rgba(0, 0, 0, 0.85)',
      colorBgMenuItemActive: 'rgba(0, 0, 0, 0.06)',
      colorBgMenuItemCollapsedElevated: 'transparent',
    },
    header: {
      colorBgHeader: 'transparent',
      colorBgScrollHeader: 'rgba(0, 0, 0, 0.04)',
      colorHeaderTitle: 'rgba(0, 0, 0, 0.85)',
      colorBgMenuItemHover: 'rgba(0, 0, 0, 0.06)',
      colorBgMenuItemSelected: 'transparent',
      colorTextMenuSelected: 'rgba(0, 0, 0, 0.85)',
      colorBgRightActionsItemHover: 'rgba(0, 0, 0, 0.06)',
      colorTextRightActionsItem: 'rgba(0, 0, 0, 0.85)',
      heightLayoutHeader: 56,
      colorTextMenu: 'rgba(0, 0, 0, 0.65)',
      colorTextMenuSecondary: 'rgba(0, 0, 0, 0.45)',
      colorTextMenuActive: 'rgba(0, 0, 0, 0.85)',
      colorBgMenuElevated: 'rgba(0, 0, 0, 0.06)',
    },
    pageContainer: {
      colorBgPageContainer: 'transparent',
      paddingInlinePageContainerContent: 40,
      paddingBlockPageContainerContent: 32,
      colorBgPageContainerFixed: '#FFFFFF',
    },
  },
};
